import makeStyles from '@mui/styles/makeStyles';
interface IProps {
  color: string;
}

export const useStyles = makeStyles({
  icon_container: {
    fill: (props: IProps) => props.color,
    flexShrink: 0,
    userSelect: 'none',
    width: '1.375rem',
    height: '1.375rem',
  },
});
